/**
 * Created by fan on 3/13/17.
 */
angular.module('smartorg.r6.cmpts.stickybar', []);
require('./sticky-bar-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.cmpts.stickybar';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/components/sticky-bar/app/js/plumbing/app.js